<script setup>
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";

const { t: __ } = useI18n();
const metrics = await useForm().post("dashboard_global_metrics");
</script>

<template>
    <div class="grid grid-cols-1 lg:grid-cols-4 sm:grid-cols-2">
        <div :class="['', 'border-gray-300 dark:border-gray-800 py-6 px-4 sm:px-6 lg:px-8']">
            <p class="text-sm font-medium leading-6 text-gray-600 dark:text-gray-400">{{ __("Projets créés") }}</p>
            <p class="flex items-baseline gap-x-2 mt-2">
                <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ metrics.projects.total }}</span>
            </p>
        </div>
        <div :class="['border-t sm:border-t-0 sm:border-l', 'border-gray-300 dark:border-gray-800 py-6 px-4 sm:px-6 lg:px-8']">
            <p class="text-sm font-medium leading-6 text-gray-600 dark:text-gray-400">{{ __("Projets complétés") }}</p>
            <p class="flex items-baseline gap-x-2 mt-2">
                <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ metrics.projects.completed }}</span>
            </p>
        </div>
        <div :class="['border-t lg:border-t-0 lg:border-l', 'border-gray-300 dark:border-gray-800 py-6 px-4 sm:px-6 lg:px-8']">
            <p class="text-sm font-medium leading-6 text-gray-600 dark:text-gray-400">{{ __("Publications publiées") }}</p>
            <p class="flex items-baseline gap-x-2 mt-2">
                <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ metrics.publications.published }}</span>
            </p>
        </div>
        <div :class="['border-t sm:border-l lg:border-t-0', 'border-gray-300 dark:border-gray-800 py-6 px-4 sm:px-6 lg:px-8']">
            <p class="text-sm font-medium leading-6 text-gray-600 dark:text-gray-400">{{ __("Publications en attente") }}</p>
            <p class="flex items-baseline gap-x-2 mt-2">
                <span class="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">{{ metrics.publications.idle }}</span>
            </p>
        </div>
    </div>
</template>
